import Home from './Home';
import About from './About';
import Team from './Team';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from './PrivacyPolicy';
import Copyright from './Copyright';
import PurchaseTerms from './PurchaseTerms';

import './style.less';

export {
  Home,
  Team,
  TermsOfUse,
  PrivacyPolicy,
  Copyright,
  PurchaseTerms,
  About
};



/** WEBPACK FOOTER **
 ** ./src/views/Home/index.js
 **/